import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { PublicFooter } from '@/components/public/PublicFooter';

export const PublicLayout = () => {
  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <div className="app-scroll-region">
          <div className="flex min-h-full flex-col">
            <div className="flex-1">
              <Outlet />
            </div>
            <PublicFooter />
          </div>
        </div>
      </main>
    </div>
  );
};
